var map = {
	"./amazon-music.svg": 1852,
	"./amazon.svg": 6663,
	"./apple-music.svg": 1129,
	"./audius.svg": 2491,
	"./bandcamp.svg": 9042,
	"./deezer.svg": 591,
	"./facebook.svg": 9387,
	"./instagram.svg": 7517,
	"./kkbox.svg": 150,
	"./shazam.svg": 2832,
	"./soundcloud.svg": 2261,
	"./spotify.svg": 4529,
	"./tidal.svg": 3855,
	"./twitter.svg": 8020,
	"./youtube-music.svg": 7559,
	"./youtube.svg": 7140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4636;